import dayjs, { Dayjs } from 'dayjs';
import { CustomDateRange } from '../types/date';

export const DEFAULT_DATE_QUERY_FORMAT = 'YYYY-MM-DD';

export const DEFAULT_RANGE_PICKER_FORMAT = 'YYYY/MM/DD';

export const DEFAULT_START_DATE = dayjs('1970-01-01');

export const getTodayDateRange = (): CustomDateRange => ({
	start: dayjs(new Date()).startOf('day'),
	end: dayjs(new Date()).endOf('day'),
});

export const getYesterdayDateRange = (): CustomDateRange => ({
	start: dayjs(new Date()).subtract(1, 'd').startOf('day'),
	end: dayjs(new Date()).subtract(1, 'd').endOf('day'),
});

export const getLast7DaysDateRange = (): CustomDateRange => ({
	start: dayjs(new Date()).subtract(6, 'd').startOf('day'),
	end: dayjs(new Date()).endOf('day'),
});

export const getLast30DaysDateRange = (): CustomDateRange => ({
	start: dayjs(new Date()).subtract(29, 'd').startOf('day'),
	end: dayjs(new Date()).endOf('day'),
});

export const getLast90DaysDateRange = (): CustomDateRange => ({
	start: dayjs(new Date()).subtract(89, 'd').startOf('day'),
	end: dayjs(new Date()).endOf('day'),
});

export const getLastYearDateRange = (): CustomDateRange => {
	const today = new Date();
	const firstDayOfThisYear = dayjs(today).startOf('y');
	const lastDayOfPreviousYear = dayjs(firstDayOfThisYear).subtract(1, 'd').endOf('d');
	const firstDayOfPreviousYear = dayjs(lastDayOfPreviousYear).startOf('y');

	return { start: firstDayOfPreviousYear, end: lastDayOfPreviousYear };
};

const isValidDate = (date: Dayjs | null) => date?.isValid() && date.isAfter(DEFAULT_START_DATE);

export const convertToValidCustomRange = (customDateRange: CustomDateRange): CustomDateRange => {
	const range: CustomDateRange = {
		start: isValidDate(customDateRange.start) ? customDateRange.start : null,
		end: isValidDate(customDateRange.end) ? customDateRange.end : null,
	};

	if (customDateRange.start?.isAfter(customDateRange.end)) return { start: null, end: null };

	return range;
};
